import { render, staticRenderFns } from "./CashDeskSelector.vue?vue&type=template&id=7d81afa4"
import script from "./CashDeskSelector.vue?vue&type=script&lang=js"
export * from "./CashDeskSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports